import React from 'react'

export default function Confirm({texto, funcao}) {
  return (
    <div className="modal fade" id="confirmModal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirmação</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {texto}
          </div>
          <div className="modal-footer" style={{justifyContent: 'space-between'}}>
            <button type="button" className="btn btn-sm btn-danger" data-dismiss="modal">Não</button>
            <button type="button" className="btn btn-sm btn-success" data-dismiss="modal" onClick={funcao}>Sim</button>
          </div>
        </div>
      </div>
    </div>
  )
}
